webpackJsonp([23],{

/***/ "57fN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_article_scss__ = __webpack_require__("ploN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_css_page_article_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_css_page_article_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_constants_index__ = __webpack_require__("5LvV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_js_common_index__ = __webpack_require__("4PxH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_utils_index__ = __webpack_require__("EgtA");










function bindEvts() {
  memberFormInit();
  commentEvtsInit();
}

function commentEvtsInit() {
  var maskObj = document.querySelector('.mask-cmmt');

  if (!maskObj) {
    __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('comment mask not found.');
    return;
  }

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].publishInit({
    badBtn: maskObj.querySelector('.yui-icon-cry0-yellow').parentNode,
    cancelBtn: '.yui-ccmmt-publish0 .btn-op.cancel',
    cancelSuccess: hideMask,
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(__WEBPACK_IMPORTED_MODULE_2_js_constants_index__["a" /* api */].gameIdPropertyName)
    },
    goodBtn: maskObj.querySelector('.yui-icon-smile0-yellow').parentNode,
    ipt: '.yui-ccmmt-publish0 textarea',
    submitBtn: '.yui-ccmmt-publish0 .btn-op.push',
    submitSuccessBefore: function submitSuccessBefore() {
      return window.location.href = window.location.href;
    },
    submitFinally: hideMask
  });

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].thumbInit({
    list: '.cmmt-blk',
    btnSelector: '.btn-thumb'
  });

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(document.querySelectorAll('.sec-cmmt .yui-thumbbtn0')), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var o = _step.value;

      o.addEventListener('click', showMask, false);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  function showMask() {
    if (!maskObj) {
      __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('comment mask not found.');
      return;
    }

    var user = __WEBPACK_IMPORTED_MODULE_3_js_common_index__["i" /* dataBus */].get('user');
    if (!user) {
      return __WEBPACK_IMPORTED_MODULE_3_js_common_index__["o" /* message */].common.pleaseLogin({
        callback: function callback() {
          var obj = document.querySelector('header a.login');
          if (obj) {
            obj.click();
          }
        },
        mode: 1
      });
    }

    var obj = $(this).find('.yui-icon-smile0-yellow');
    if (obj.length > 0) {
      $('.mask-cmmt .yui-icon-cry0-yellow').toggleClass('yui-icon-cry0-yellow yui-icon-cry0-gray');
    }

    obj = $(this).find('.yui-icon-cry0-yellow');
    if (obj.length > 0) {
      $('.mask-cmmt .yui-icon-smile0-yellow').toggleClass('yui-icon-smile0-yellow yui-icon-smile0-gray');
    }

    maskObj.style.display = 'block';
  }

  function hideMask() {
    if (!maskObj) {
      __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["f" /* log */].e('comment mask not found.');
      return;
    }

    var obj = document.querySelector('.mask-cmmt .yui-icon-smile0-yellow, .mask-cmmt .yui-icon-smile0-gray');
    if (obj) {
      $(obj).addClass('yui-icon-smile0-yellow').removeClass('yui-icon-smile0-gray');
    }

    obj = document.querySelector('.mask-cmmt .yui-icon-cry0-yellow, .mask-cmmt .yui-icon-cry0-gray');
    if (obj) {
      $(obj).addClass('yui-icon-cry0-yellow').removeClass('yui-icon-cry0-gray');
    }

    document.querySelector('.mask-cmmt textarea').value = '';
    maskObj.style.display = 'none';
  }
}

function cmmtUIInit() {
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadCmmtList({
    mode: 0,
    params: {
      desc: '.desc-load',
      id: '.sec-cmmt',
      pageList: '.yui-pagination0 .pagelist',
      target: '.sec-cmmt .cmmt-blk'
    }
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadGood({
    bad: '.txt-add.bad',
    data: {
      gameId: document.querySelector('.sec-cmmt').getAttribute(__WEBPACK_IMPORTED_MODULE_2_js_constants_index__["a" /* api */].gameIdPropertyName)
    },
    good: '.txt-add.good'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["h" /* comment */].loadUserData({
    avatar: '.yui-ccmmt-top0 .avatar img',
    mode: 1,
    mode1Callback: function mode1Callback() {
      var obj = document.querySelector('header a.login');
      if (obj) {
        obj.click();
      }
    },
    userName: '.yui-ccmmt-top0 .avatar .username'
  });
}

function memberFormInit() {
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].closeForm.init();
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].forgetPwdFormInit({
    form: '.yui-memberform0-forgetpwd',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].loginFormInit({
    success: function success() {
      window.location.href = window.location.href;
    },
    form: '.yui-memberform0-login',
    mask: '.mask-member'
  });
  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["n" /* memberShip */].registerFormInit({
    form: '.yui-memberform0-register',
    mask: '.mask-member'
  });
}

function QRCodeInit() {
  var parser = new __WEBPACK_IMPORTED_MODULE_4_js_utils_index__["a" /* UrlParser */]();

  __WEBPACK_IMPORTED_MODULE_3_js_common_index__["q" /* qrcode */].init({
    ht: 140,
    prefix: parser.domainName,
    target: '.yui-qrbtn0 .qrcode',
    wt: 140
  });
}

function uiInit() {
  QRCodeInit();
  cmmtUIInit();
}

window._dataBus.get('domReadyObserver').subscribe(function () {
  uiInit();
  bindEvts();
});

/***/ }),

/***/ "ploN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["57fN"]);


// WEBPACK FOOTER //
// js/article.js